import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const LabIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 26"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M9 19V22C9 23.6569 10.3431 25 12 25C13.6569 25 15 23.6569 15 22V1H9V19ZM9 19H12M9 7H15M9 13H12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

LabIcon.displayName = 'LabIcon';
